import { SET_ART_WALL_PRODUCTS } from './../const';

export default (artWallProducts) => {
  return {
    type: SET_ART_WALL_PRODUCTS,
    artWallProducts
  }
};
